package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter9.getFacciamoIlPuntoQuizContent
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_le_frasi_avverbiali_1
import gero.composeapp.generated.resources.exp_content_le_frasi_avverbiali_2
import gero.composeapp.generated.resources.exp_content_le_frasi_avverbiali_3
import gero.composeapp.generated.resources.exp_content_le_frasi_avverbiali_4
import gero.composeapp.generated.resources.exp_content_le_frasi_avverbiali_5
import gero.composeapp.generated.resources.exp_title_le_frasi_avverbiali

fun getLeFrasiAvverbialiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_le_frasi_avverbiali,
            content = Res.string.exp_content_le_frasi_avverbiali_1,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_frasi_avverbiali,
            content = Res.string.exp_content_le_frasi_avverbiali_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_frasi_avverbiali,
            content = Res.string.exp_content_le_frasi_avverbiali_3,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_frasi_avverbiali,
            content = Res.string.exp_content_le_frasi_avverbiali_4,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_frasi_avverbiali,
            content = Res.string.exp_content_le_frasi_avverbiali_5,
            face = Faces.Happy,
            character = Characters.Masko,
        )
    )
}

fun getLeFrasiAvverbialiQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String,
    adverbialSentencesTsvContent: String? = null
): List<IQuizContent> {
    return getFacciamoIlPuntoQuizContent(hiero, words, languageCode, adverbialSentencesTsvContent)
}
